<template>
    <div class="listmain "> 
        <h1 class="firTitle">FreeRTOS硬件SDK</h1>
        <p>为FreeRTOS硬件设备提供语音OS能力，目前已在demo测试中，即将上线。。
       </p>
    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/FSDK.vue